<template>
  <q-modal v-model="show_dashboard" :content-css="{minWidth: '100vw', maxWidth: '100vw', minHeight: '100vh'}">
    <q-modal-layout>
        <q-toolbar slot="header">
            <q-btn flat round dense @click="show_dashboard = false" icon="fas fa-times" />
            <q-toolbar-title>
                {{ $t('overview') }}
            </q-toolbar-title>
        </q-toolbar>

        <div class="layout-padding">
              <div class="row reverse q-mb-sm">
                  <div class="col-xs-12 col-sm-4 text-right" v-if="loaded_data">
                      <span class="q-subheading text-weight-light">{{ `${$t('last_update_in')} ${updated_date}` }}</span>
                  </div>
              </div>

              <div class="row gutter-md" v-if="loaded_data">
                  <div class="col-xs-12 col-sm-6 col-lg-4">
                      <totals
                          :title="$t('user')"
                          :active="users.qty_active_users"
                          :active_lb="$t('active', {count: users.qty_active_users})"
                          :inactive="users.qty_inactive_users"
                          :inactive_lb="$t('inactive', {count: users.qty_inactive_users})"
                          :deleted="users.qty_deleted_users"
                          :deleted_lb="$t('deleted', {count: users.qty_deleted_users})"
                          :self_registered_lb="$t('self_registered', {count: users.qty_auto_register_users})"
                          :self_registered="users.qty_auto_register_users"
                          :pre_registered_lb="$t('pre_registered', {count: users.qty_pre_register_users})"
                          :pre_registered="users.qty_pre_register_users"
                          :others_lb="$t('other', {count: users.qty_other_users})"
                          :others="users.qty_other_users"
                          icon="fal fa-user"
                          module_type="users"
                      />
                  </div>

                  <div class="col-xs-12 col-sm-6 col-lg-4" v-if="clientModules.has_courses">
                      <totals
                          :title="$t('training')"
                          :active="trainings.qty_published_trainings"
                          :active_lb="$t('published', {count: trainings.qty_published_trainings})"
                          :inactive="trainings.qty_unpublished_trainings"
                          :inactive_lb="$t('unpublished', {count: trainings.qty_unpublished_trainings} )"
                          :deleted="trainings.qty_deleted_trainings"
                          :deleted_lb="$t('deleted', {count: trainings.qty_deleted_trainings})"
                          :certificates="trainings.qty_total_user_results"
                          :certificates_lb="$t('certificate', {count: trainings.qty_total_user_results})"
                          icon="fal fa-graduation-cap"
                          module_type="training"
                      />
                  </div>

                  <div class="col-xs-12 col-sm-6 col-lg-4" v-if="clientModules.has_trails">
                      <totals
                          :title="$t('trails')"
                          :active="trails.qty_published_trails"
                          :active_lb="$t('published', {count: trails.qty_published_trails })"
                          :inactive="trails.qty_unpublished_trails"
                          :inactive_lb="$t('unpublished', {count:trails.qty_unpublished_trails})"
                          :deleted="trails.qty_deleted_trails"
                          :deleted_lb="$t('deleted', {count:trails.qty_deleted_trails})"
                          :certificates="trails.qty_total_user_results"
                          :certificates_lb="$t('certificate', {count: trails.qty_total_user_results})"
                          icon="fal fa-sign"
                          module_type="trails"
                      />
                  </div>

                  <div class="col-xs-12 col-sm-6 col-lg-4" v-if="clientModules.has_presential">
                      <totals
                          :title="$t('presential')"
                          :active="presentials.qty_presential_schedule"
                          :active_lb="$t('scheduled', {count: presentials.qty_presential_schedule })"
                          :inactive="presentials.qty_presential_waiting_results"
                          :inactive_lb="$t('awaiting_result', {count: presentials.qty_presential_waiting_results})"
                          :deleted="presentials.qty_presential_finished"
                          :deleted_lb="$t('finished', {count: presentials.qty_presential_finished})"
                          :certificates="presentials.qty_total_user_results"
                          :certificates_lb="$t('certificate', {count: presentials.qty_total_user_results})"
                          icon="fal fa-users-class"
                          module_type="presential"
                      />
                  </div>

                  <div class="col-xs-12 col-sm-6 col-lg-4" v-if="clientModules.has_webcasts">
                      <totals
                          :title="$t('webinar')"
                          :active="webcasts.qty_published_webcasts"
                          :active_lb="$t('published', {count:webcasts.qty_published_webcasts})"
                          :inactive="webcasts.qty_finished_webcasts"
                          :inactive_lb="$t('finished', {count:webcasts.qty_finished_webcasts})"
                          :deleted="webcasts.qty_deleted_webcasts"
                          :deleted_lb="$t('deleted', {count:webcasts.qty_deleted_webcasts})"
                          :certificates="webcasts.qty_total_user_results"
                          :certificates_lb="$t('certificate', {count:webcasts.qty_total_user_results})"
                          icon="fal fa-broadcast-tower"
                          module_type="webcast"
                      />
                  </div>

                  <div class="col-xs-12 col-sm-6 col-lg-4" v-if="clientModules.has_live_classes">
                      <totals
                          :title="$t('training')"
                          :active="live_classes.qty_published_live_classes"
                          :active_lb="$t('published', {count: live_classes.qty_published_live_classes})"
                          :inactive="live_classes.qty_unpublished_live_classes"
                          :inactive_lb="$t('unpublished', {count: live_classes.qty_unpublished_live_classes} )"
                          :deleted="live_classes.qty_deleted_live_classes"
                          :deleted_lb="$t('deleted', {count: live_classes.qty_deleted_live_classes})"
                          :others="live_classes.qty_finished_live_classes"
                          :others_lb="$t('finished', {count: live_classes.qty_finished_live_classes})"
                          :certificates="live_classes.qty_total_user_results"
                          :certificates_lb="$t('certificate', {count: live_classes.qty_total_user_results})"
                          icon="fal fa-chalkboard-teacher"
                          module_type="live_class"
                      />
                  </div>
              </div>

              <div class="row gutter-md q-mt-lg" v-if="loaded_data">
                  <div class="col-12" v-if="$q.platform.is.desktop && clientModules.has_courses">
                      <q-card class="full-height">
                          <q-card-title class="bg-secondary">
                              <span class="q-headline text-white">
                                  <q-icon name="fal fa-tasks" /> {{ $t('training_progress') }}
                              </span>
                          </q-card-title>

                          <q-card-separator />

                          <q-card-main>
                              <div class="row gutter-sm">
                                  <div class="col-12">
                                      <div class="row text-weight-medium q-title">
                                          <div class="col-3">
                                              {{ $t('profiles') }}
                                          </div>

                                          <div class="col-3">
                                              {{ $t('users') }}
                                          </div>

                                          <div class="col-3">
                                              {{ $t('published_trainings') }}
                                          </div>

                                          <div class="col-3">
                                              {{ $t('certificates') }}
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-12" v-for="(profile, index) in profiles" :key="index">
                                      <div class="row">
                                          <div class="col-3">
                                              {{ profile.profile }}
                                          </div>

                                          <div class="col-3">
                                              {{ profile.users }}
                                          </div>

                                          <div class="col-3">
                                              {{ profile.training_published }}
                                          </div>

                                          <div class="col-3">
                                              {{ profile.training_results }}
                                          </div>

                                          <div class="col-12">
                                              <q-slider
                                              v-model="profile.training_results"
                                              :min="0"
                                              :max="getMax(profile.users, profile.training_published)"
                                              :step="1"
                                              label
                                              label-always
                                              readonly
                                              :label-value="`${getPercentage(profile.users, profile.training_results, profile.training_published)}%`"
                                          />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </q-card-main>
                      </q-card>
                  </div>

                  <div class="col-12" v-if="$q.platform.is.desktop && clientModules.has_trails">
                      <q-card class="full-height">
                          <q-card-title class="bg-secondary">
                              <span class="q-headline text-white">
                                  <q-icon name="fal fa-sign" /> {{ $t('trail_progress') }}
                              </span>
                          </q-card-title>

                          <q-card-separator />

                          <q-card-main>
                              <div class="row gutter-sm">
                                  <div class="col-12">
                                      <div class="row text-weight-medium q-title">
                                          <div class="col-3">
                                              {{ $t('profiles') }}
                                          </div>

                                          <div class="col-3">
                                              {{ $t('users') }}
                                          </div>

                                          <div class="col-3">
                                              {{ $t('published_trails') }}
                                          </div>

                                          <div class="col-3">
                                              {{ $t('certificates') }}
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-12" v-for="(profile, index) in profiles" :key="index">
                                      <div class="row">
                                          <div class="col-3">
                                              {{ profile.profile }}
                                          </div>

                                          <div class="col-3">
                                              {{ profile.users }}
                                          </div>

                                          <div class="col-3">
                                              {{ profile.trail_published }}
                                          </div>

                                          <div class="col-3">
                                              {{ profile.trail_results }}
                                          </div>

                                          <div class="col-12">
                                              <q-slider
                                              v-model="profile.trail_results"
                                              :min="0"
                                              :max="getMax(profile.users, profile.trail_published)"
                                              :step="1"
                                              label
                                              label-always
                                              readonly
                                              :label-value="`${getPercentage(profile.users, profile.trail_results, profile.trail_published)}%`"
                                          />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </q-card-main>
                      </q-card>
                  </div>

                  <div class="col-12" v-if="$q.platform.is.mobile && clientModules.has_courses">
                      <q-card>
                          <q-card-title class="bg-secondary">
                              <span class="q-headline text-white">
                                  <q-icon name="fal fa-tasks" /> {{ $t('training_progress') }}
                              </span>
                          </q-card-title>

                          <q-card-separator />

                          <q-card-main>
                              <div class="row">
                                  <div class="col-12 q-mb-md" v-for="(profile, index) in profiles" :key="index">
                                      <div class="row">
                                          <div class="col-12 q-subheading text-weight-regular">
                                              {{ $t('profiles') }}: {{ profile.profile }}
                                          </div>
                                          <div class="col-12 q-subheading text-weight-regular">
                                              {{ $t('users') }}: {{ profile.users }}
                                          </div>
                                          <div class="col-12 q-subheading text-weight-regular">
                                              {{ $t('published_trainings') }}: {{ profile.training_published }}
                                          </div>
                                          <div class="col-12 q-subheading text-weight-regular">
                                              {{ $t('certificates') }}: {{ profile.training_results }}
                                          </div>
                                          <div class="col-12">
                                              <q-slider
                                              v-model="profile.training_results"
                                              :min="0"
                                              :max="getMax(profile.users, profile.training_published)"
                                              :step="1"
                                              label
                                              label-always
                                              readonly
                                              :label-value="`${getPercentage(profile.users, profile.training_results, profile.training_published)}%`"
                                          />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </q-card-main>
                      </q-card>
                  </div>

                  <div class="col-12" v-if="$q.platform.is.mobile && clientModules.has_trails">
                      <q-card>
                          <q-card-title class="bg-secondary">
                              <span class="q-headline text-white">
                                  <q-icon name="fal fa-sign" /> {{ $t('trail_progress') }}
                              </span>
                          </q-card-title>

                          <q-card-separator />

                          <q-card-main>
                              <div class="row">
                                  <div class="col-12 q-mb-md" v-for="(profile, index) in profiles" :key="index">
                                      <div class="row">
                                          <div class="col-12 q-subheading text-weight-regular">
                                              {{ $t('profiles') }}: {{ profile.profile }}
                                          </div>
                                          <div class="col-12 q-subheading text-weight-regular">
                                              {{ $t('users') }}: {{ profile.users }}
                                          </div>
                                          <div class="col-12 q-subheading text-weight-regular">
                                              {{ $t('published_trails') }}: {{ profile.trail_published }}
                                          </div>
                                          <div class="col-12 q-subheading text-weight-regular">
                                              {{ $t('certificates') }}: {{ profile.trail_results }}
                                          </div>
                                          <div class="col-12">
                                              <q-slider
                                              v-model="profile.trail_results"
                                              :min="0"
                                              :max="getMax(profile.users, profile.trail_published)"
                                              :step="1"
                                              label
                                              label-always
                                              readonly
                                              :label-value="`${getPercentage(profile.users, profile.trail_results, profile.trail_published)}%`"
                                          />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </q-card-main>
                      </q-card>
                  </div>
              </div>
          </div>
    </q-modal-layout>
  </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Totals from 'components/admin/overview/Totals'
import { date } from 'quasar'
const { formatDate } = date

export default {
    name: 'AdminOverviewDashboard',

    props: ['show_dashboard_modal'],

    data() {
      return {
          users: [],
          trainings: [],
          trails: [],
          presentials: [],
          webcasts: [],
          libraries: [],
          live_classes: [],
          tags: [],
          profiles: [],
          loaded_data: false,
          updated_date: null,
          clientModules: {
              has_courses: false,
              has_trails: false,
              has_presential: false,
              has_live_classes: false,
              has_podcasts: false,
              has_webcasts: false
          }
      }
    },

    components: {
      'totals': Totals
    },

    computed: {
      ...mapGetters({
            access_token: 'common/access_token',
            id_user_client_selected: 'common/id_user_client_selected',
            clients: 'params/clients',
            user_module_items: 'common/user_module_items',
        }),

        show_dashboard: {
            get() {
                return this.show_dashboard_modal
            },
            set() {
                this.$emit('hide_dashboard_modal', '')
            }
        },

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/admin_overview/overview/`, this.getHeader)
            .then(response => {
                this.users = response.data.users
                this.trainings = response.data.group_trainings
                this.trails = response.data.trails
                this.presentials = response.data.presential_events
                this.webcasts = response.data.webcasts
                this.libraries = response.data.library_files
                this.tags = response.data.tags
                this.live_classes = response.data.live_classes
                this.updated_date = date.formatDate(response.data.updated_date, 'DD/MM/YYYY HH:mm:ss')

                response.data.users.profiles.forEach(profile => {
                    let trail = []
                    let training = []

                    let obj_trail = response.data.trails.profiles.find((obj) => { return obj.profile === profile.profile })
                    if (obj_trail) trail = obj_trail

                    let obj_training = response.data.group_trainings.profiles.find((obj) => { return obj.profile === profile.profile })
                    if (obj_training) training = obj_training

                    this.profiles.push({
                        profile: profile.profile,
                        users: profile.qty_active,
                        training_results: training.qty_active_user_results,
                        training_published: training.qty_published_group_trainings,
                        trail_results: trail.qty_active_user_results,
                        trail_published: trail.qty_published_trails
                    })
                })

                this.loaded_data = true
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        checkClientModules() {
            const client = this.clients.find(obj => obj.id === this.id_user_client_selected)
            if (client) {
                for (const [key, value] of Object.entries(this.clientModules)) {
                    if (client[key] !== undefined) {
                        this.clientModules[key] = client[key]
                    }
                }
            } else return
        },

        getPercentage(users, results, published) {
            if (users == 0 || results == 0 || published == 0) return 0
            else {
                let count = parseFloat((results / (users * published)) * 100)
                return !isNaN(count) ? count.toFixed(2) : 0
            }
        },

        getMax(users, published) {
            if (published == 0 || users == 0) return 1
            else return published * users
        },
    },

    mounted () {
      this.fetchData()
      this.checkClientModules()
    },

}
</script>

<style>

</style>
